import { Player } from "@lottiefiles/react-lottie-player";
import { debounce } from "lodash";
import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Loading from "../../components/Loading/Loading";
import CCSavedRemoveModal from "../../components/Modals/CCSavedRemoveModal/CCSavedRemoveModal";
import CCSaveModal from "../../components/Modals/CCSaveModal/CCSaveModal";
import DailyLimitErrorModal from "../../components/Modals/DailyLimitErrorModal/DailyLimitErrorModal";
import GameResultModal from "../../components/Modals/GameResultModal/GameResultModal";
import InstantRewardModal from "../../components/Modals/InstantRewardModal/InstantRewardModal";
import OfferModal, {
  PaymentModalType,
} from "../../components/Modals/OfferModal/OfferModal";
import OtpModal from "../../components/Modals/OtpModal/OtpModal";
import PayByMeModal from "../../components/Modals/PayByMeModal/PayByMeModal";
import PaymentErrorModal, {
  PaymentErrorCallbackType,
} from "../../components/Modals/PaymentErrorModal/PaymentErrorModal";
import { FormValuesAcceptance } from "../../core/models/custom/formValuesAcceptance";
import { FormValuesCCSaveExtended } from "../../core/models/custom/formValuesCCSaveExtended";
import { FormValuesOtp } from "../../core/models/custom/formValuesOtp";
import { OfferValue } from "../../core/models/custom/offerValue";
import { AnswerDto } from "../../core/models/dtos/answer.dto";
import { CardDto } from "../../core/models/dtos/card.dto";
import { ErrorDto } from "../../core/models/dtos/error.dto";
import { MeDto } from "../../core/models/dtos/me.dto";
import { AnswerStatus } from "../../core/models/enums/answerStatus";
import { ApiEvent } from "../../core/models/enums/apiEvent";
import { RewardDescription } from "../../core/models/enums/rewardDescription";
import { AnswerRequest } from "../../core/models/requests/answer.request";
import { PickedAnswerRequest } from "../../core/models/requests/pickedAnswer.request";
import { ValidateOtpRequest } from "../../core/models/requests/validateOtp.request";
import {
  answer,
  answerReset,
} from "../../core/services/answerService/answer/actions";
import { answerRequest } from "../../core/services/answerService/answer/repository";
import { AnswerState } from "../../core/services/answerService/answer/types";
import { getAnswerStatusRequest } from "../../core/services/answerService/getAnswerStatus/repository";
import { GetAnswerStatusState } from "../../core/services/answerService/getAnswerStatus/types";
import { pickedAnswer } from "../../core/services/answerService/pickedAnswer/actions";
import { PickedAnswerState } from "../../core/services/answerService/pickedAnswer/types";
import { validateOtp } from "../../core/services/answerService/validateOtp/actions";
import { ValidateOtpState } from "../../core/services/answerService/validateOtp/types";
import { setApiError } from "../../core/services/appService/setApiError/actions";
import { SetApiErrorState } from "../../core/services/appService/setApiError/types";
import { deleteCard } from "../../core/services/cardService/deleteCard/actions";
import { DeleteCardState } from "../../core/services/cardService/deleteCard/types";
import { apiEventRequest } from "../../core/services/eventService/apiEvent/repository";
import FirebaseService from "../../core/services/firebaseService/firebase.service";
import {
  getCurrentQuestion,
  getCurrentQuestionReset,
} from "../../core/services/questionService/getCurrentQuestion/actions";
import { GetCurrentQuestionState } from "../../core/services/questionService/getCurrentQuestion/types";
import { getMe } from "../../core/services/userService/getMe/actions";
import { Constants } from "../../core/utilities/constants";
import { Errors } from "../../core/utilities/errors";
import { Helpers } from "../../core/utilities/helpers";
import { IStore } from "../../core/utilities/reducers";
import Option from "./Option/Option";
import "./QuestionPage.scss";

interface IProps {
  me?: MeDto;
  getMe: () => void;
  getCurrentQuestionState: GetCurrentQuestionState;
  getCurrentQuestion: () => void;
  getCurrentQuestionReset: () => void;
  answerState: AnswerState;
  answer: (request: AnswerRequest, isEtkApproved?: boolean) => void;
  answerReset: () => void;
  pickedAnswerState: PickedAnswerState;
  pickedAnswer: (request: PickedAnswerRequest) => void;
  getAnswerStatusState: GetAnswerStatusState;
  getAnswerStatus: (answerId: number) => void;
  deleteCardState: DeleteCardState;
  deleteCard: () => void;
  validateOtpState: ValidateOtpState;
  validateOtp: (request: ValidateOtpRequest) => void;
  apiErrorState: SetApiErrorState;
  setApiError: (error?: ErrorDto) => void;
}

interface IState {
  isLottiePlayerLoading: boolean;
  optionsAvailabilityTimeout?: NodeJS.Timeout;
  selectedOptionId?: number;
  paymentModal?: PaymentModalType;
  answerResult?: AnswerDto;
  isEtkApproved: boolean;
  buyForHump: boolean;
  isCCSavedRemoveModalVisible: boolean;
  isDailyLimitErrorVisible: boolean;
  isGameResultModalAvailable: boolean;
  instantRewardDescription?: RewardDescription;
  retryAnswerRequest?: AnswerRequest;
}

class QuestionPage extends Component<IProps> {
  state: IState = {
    isLottiePlayerLoading: true,
    optionsAvailabilityTimeout: undefined,
    selectedOptionId: undefined,
    paymentModal: undefined,
    answerResult: undefined,
    isEtkApproved: false,
    buyForHump: false,
    isCCSavedRemoveModalVisible: false,
    isDailyLimitErrorVisible: false,
    isGameResultModalAvailable: false,
    instantRewardDescription: undefined,
    retryAnswerRequest: undefined,
  };

  private readonly offer: OfferValue;

  constructor(props: IProps) {
    super(props);
    this.offer = FirebaseService.getOffer(
      Math.floor(Math.random() * FirebaseService.getOfferValues().length)
    );
  }

  componentDidMount() {
    this.props.getCurrentQuestion();
  }

  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<{}>,
    snapshot?: any
  ) {
    if (
      prevProps.getCurrentQuestionState.loading &&
      !this.props.getCurrentQuestionState.loading
    ) {
      if (this.props.getCurrentQuestionState.data) {
        this.setState({
          isLottiePlayerLoading: true,
          optionsAvailabilityTimeout: this.setOptionsAvailabilityTimeout(),
          selectedOptionId: undefined,
          paymentModal: undefined,
          answerResult: undefined,
          isGameResultModalAvailable: false,
        });
        apiEventRequest({
          ...Helpers.getApiEventCoreData(this.props.me),
          event: ApiEvent.QUESTION_SENT,
          value1: this.props.getCurrentQuestionState.data.id,
        }).catch();
      }
    }

    if (prevProps.answerState.loading && !this.props.answerState.loading) {
      if (this.props.answerState.data) {
        this.syncAnswerResult(this.props.answerState.data.id);
      }
    }

    if (
      prevProps.validateOtpState.loading &&
      !this.props.validateOtpState.loading
    ) {
      if (this.props.validateOtpState.data) {
        this.handleAnswerResponse(this.props.validateOtpState.data);
      }
    }
  }

  private setOptionsAvailabilityTimeout(): NodeJS.Timeout {
    return setTimeout(() => {
      this.setState({ optionsAvailabilityTimeout: undefined });
    }, Constants.optionsAvailabilityTimeout);
  }

  private async syncAnswerResult(answerId: number): Promise<void> {
    while (true) {
      const response = await getAnswerStatusRequest(answerId);
      if (response.state === AnswerStatus.PENDING) {
        this.setState({ answerResult: response });
        await Helpers.wait(Constants.answerStatusCheckInterval);
      } else if (response.state === AnswerStatus.PENDING_OTP) {
        this.setState({ answerResult: response });
        break;
      } else {
        this.handleAnswerResponse(response);
        break;
      }
    }
  }

  private getInstantRewardDescription(
    answerDto: AnswerDto
  ): RewardDescription | undefined {
    const instantReward = answerDto.rewards?.filter((reward) => {
      return (
        reward.description === RewardDescription.instantWHump ||
        reward.description === RewardDescription.instantWoHump
      );
    });
    if (instantReward && instantReward.length > 0) {
      return instantReward[0].description;
    }
    return undefined;
  }

  private handleAnswerResponse(response: AnswerDto): void {
    const instantRewardDescription = this.getInstantRewardDescription(response);
    const paymentModal =
      response.state === AnswerStatus.FAIL
        ? this.state.paymentModal
        : undefined;
    this.setState({
      paymentModal,
      instantRewardDescription,
      answerResult: response,
    });
    this.logSuccessAnswerEvents(response, instantRewardDescription);
    this.props.getMe();
    this.props.answerReset();
  }

  private logSuccessAnswerEvents(
    answerDto: AnswerDto,
    instantRewardDescription?: RewardDescription
  ): void {
    FirebaseService.logEvent(FirebaseService.user_count_answered);
    if (answerDto.state === AnswerStatus.SUCCESS) {
      let value2: number | undefined;
      switch (instantRewardDescription) {
        case RewardDescription.instantWHump:
          value2 = 3;
          break;
        case RewardDescription.instantWoHump:
          value2 = 1;
          break;
      }
      apiEventRequest({
        ...Helpers.getApiEventCoreData(this.props.me),
        event: ApiEvent.PAYMENT_SUCCESS_CC,
        value1: this.offer.id,
        value2,
      }).catch();
    }
    let value1: number | undefined;
    let value2: number | undefined;
    if (answerDto.rewards) {
      if (answerDto.rewards.length > 0) {
        value1 = answerDto.rewards[0].amount;
      }
      if (answerDto.rewards.length > 1) {
        value2 = answerDto.rewards[1].amount;
      }
    }
    const value3 =
      answerDto.state !== AnswerStatus.SUCCESS ? answerDto.state : undefined;
    apiEventRequest({
      ...Helpers.getApiEventCoreData(this.props.me),
      event: ApiEvent.POINTS_REWARD_WALLET,
      value1,
      value2,
      value3,
    }).catch();
  }

  debouncedPaymentModalOpening = debounce(() => {
    this.setState({ paymentModal: PaymentModalType.payment });
  }, Constants.selectOptionTimeout);

  private sendAnswerRequest(
    request: AnswerRequest,
    isEtkApproved?: boolean
  ): void {
    this.setState({ retryAnswerRequest: request });
    this.props.answer(request, isEtkApproved);
  }

  private handleSelectOption(id: number): void {
    if (
      this.props.answerState.loading ||
      this.props.answerState.data ||
      !!this.state.answerResult
    ) {
      return;
    }
    this.setState({ selectedOptionId: id });
    apiEventRequest({
      ...Helpers.getApiEventCoreData(this.props.me),
      event: ApiEvent.ANSWER_OPTION_PICKED,
      value1: id,
    }).catch();
    this.props.pickedAnswer({ optionId: id });
    if (!!this.props.me?.answerLimitReached) {
      this.setState({ isDailyLimitErrorVisible: true });
      return;
    }
    if (this.props.me?.remainingHumpCount) {
      const request: AnswerRequest = {
        optionId: id,
        saveCard: false,
        buyForHump: false,
        mobilePayment: false,
      };
      this.sendAnswerRequest(request);
      apiEventRequest({
        ...Helpers.getApiEventCoreData(this.props.me),
        event: ApiEvent.GAMEPLAY_TOKEN_USED,
      }).catch();
    } else {
      this.debouncedPaymentModalOpening();
    }
  }

  private makeGameResultModalAvailableIfValid(): void {
    if (this.isAnswerResultStateSuccess()) {
      this.setState({ isGameResultModalAvailable: true });
    }
  }

  private isOptionDisabled(id: number): boolean {
    return (
      !!this.state.optionsAvailabilityTimeout ||
      (!!this.state.selectedOptionId && this.state.selectedOptionId !== id)
    );
  }

  private setCCSavedRemoveModalVisibility(isVisible: boolean): void {
    this.setState({ isCCSavedRemoveModalVisible: isVisible });
  }

  private handleModalOfferApprovalSavedCard(
    buyForHump: boolean,
    card?: CardDto
  ): void {
    if (card) {
      if (!this.state.selectedOptionId) {
        alert("selectedOptionId undefined");
        return;
      }
      FirebaseService.logEvent(FirebaseService.user_count_offer_credit_card);
      apiEventRequest({
        ...Helpers.getApiEventCoreData(this.props.me),
        event: ApiEvent.OFFER_CREDIT_CARD,
      }).catch();
      const request: AnswerRequest = {
        optionId: this.state.selectedOptionId,
        cardGuid: card.guid,
        saveCard: false,
        mobilePayment: false,
        buyForHump,
      };
      this.sendAnswerRequest(request);
    } else {
      this.handleModalOfferClose();
    }
  }

  private handleModalOfferApprovalAcceptance(
    buyForHump: boolean,
    values?: FormValuesAcceptance
  ): void {
    if (values) {
      if (values.saveCard) {
        this.setState({
          paymentModal: PaymentModalType.ccSave,
          isEtkApproved: values.etk,
          buyForHump,
        });
      } else {
        if (!this.state.selectedOptionId) {
          alert("selectedOptionId undefined");
          return;
        }
        FirebaseService.logEvent(FirebaseService.user_count_offer_credit_card);
        apiEventRequest({
          ...Helpers.getApiEventCoreData(this.props.me),
          event: ApiEvent.OFFER_CREDIT_CARD,
        }).catch();
        const request: AnswerRequest = {
          optionId: this.state.selectedOptionId,
          saveCard: false,
          mobilePayment: false,
          buyForHump,
        };
        this.sendAnswerRequest(request, values.etk);
      }
    } else {
      this.handleModalOfferClose();
    }
  }

  private async handleModalOfferApprovalMobile(
    buyForHump: boolean,
    resendCode = false
  ): Promise<void> {
    if (!this.state.selectedOptionId) {
      alert("selectedOptionId undefined");
      return;
    }
    this.setState({ buyForHump }); // For resend opt code logic
    FirebaseService.logEvent(FirebaseService.user_count_offer_mobile_payment);
    apiEventRequest({
      ...Helpers.getApiEventCoreData(this.props.me),
      event: ApiEvent.OFFER_MOBILE_PAYMENT,
    }).catch();
    const request: AnswerRequest = {
      optionId: this.state.selectedOptionId,
      saveCard: false,
      mobilePayment: true,
      buyForHump,
    };
    if (resendCode) {
      // Do not disturb the flow. Just send request for otp
      try {
        const response = await answerRequest(request);
        this.setState({ answerResult: response });
      } catch (e) {}
    } else {
      this.sendAnswerRequest(request);
    }
  }

  private handleModalOtp(values?: FormValuesOtp): void {
    if (values) {
      if (!this.state.answerResult?.id) {
        alert("answerId undefined");
        return;
      }
      const request: ValidateOtpRequest = {
        answerId: this.state.answerResult.id,
        otp: values.otp,
      };
      this.props.validateOtp(request);
    } else {
      this.setState({
        answerResult: undefined,
      });
    }
  }

  private handleModalOtpNewCode(): void {
    this.handleModalOfferApprovalMobile(this.state.buyForHump, true);
  }

  private handleModalOfferClose(): void {
    this.setState({
      selectedOptionId: undefined,
      paymentModal: undefined,
    });
  }

  private handleModalCCSave(values?: FormValuesCCSaveExtended): void {
    if (values) {
      if (!this.state.selectedOptionId) {
        alert("selectedOptionId undefined");
        return;
      }
      FirebaseService.logEvent(FirebaseService.user_count_offer_credit_card);
      apiEventRequest({
        ...Helpers.getApiEventCoreData(this.props.me),
        event: ApiEvent.OFFER_CREDIT_CARD,
      }).catch();
      const request: AnswerRequest = {
        optionId: this.state.selectedOptionId,
        buyForHump: this.state.buyForHump,
        saveCard: true,
        card: { ...values },
        mobilePayment: false,
      };
      this.sendAnswerRequest(request, this.state.isEtkApproved);
    } else {
      this.setState({ paymentModal: PaymentModalType.payment });
    }
  }

  private handleModalCCSavedRemove(isApproved: boolean): void {
    this.setCCSavedRemoveModalVisibility(false);
    if (isApproved) {
      this.props.deleteCard();
    }
  }

  private handleModalInstantReward(): void {
    this.setState({ instantRewardDescription: undefined });
  }

  private handleModalGameResult(): void {
    this.props.getCurrentQuestion();
  }

  private handleModalDailyLimitError(): void {
    this.setState({ isDailyLimitErrorVisible: false });
  }

  private handleModalPaymentError(type?: PaymentErrorCallbackType): void {
    this.props.setApiError();
    switch (type) {
      case PaymentErrorCallbackType.retry:
        const request = this.state.retryAnswerRequest;
        if (!request) {
          alert("Retry failed!");
        } else {
          this.sendAnswerRequest(request);
        }
        this.setState({
          answerResult: undefined,
        });
        break;
      case PaymentErrorCallbackType.payWithCC:
        this.setState({
          paymentModal: PaymentModalType.payment,
          answerResult: undefined,
        });
        break;
      case PaymentErrorCallbackType.payWithMobile:
        this.setState({
          paymentModal: PaymentModalType.paymentMobile,
          answerResult: undefined,
        });
        break;
      default:
        this.setState({
          selectedOptionId: undefined,
          paymentModal: undefined,
          answerResult: undefined,
        });
    }
  }

  private isAnswerResultStateSuccess(): boolean {
    return (
      this.state.answerResult?.state === AnswerStatus.SUCCESS ||
      this.state.answerResult?.state === AnswerStatus.HUMP ||
      this.state.answerResult?.state === AnswerStatus.FREE
    );
  }

  private renderModalOffer(): ReactNode {
    switch (this.state.paymentModal) {
      case PaymentModalType.payment:
      case PaymentModalType.paymentMobile:
        return (
          <OfferModal
            me={this.props.me}
            offer={this.offer}
            isLoading={
              this.props.deleteCardState.loading ||
              this.props.answerState.loading ||
              this.state.answerResult?.state === AnswerStatus.PENDING
            }
            isLoadingCardDelete={this.props.deleteCardState.loading}
            type={this.state.paymentModal}
            callbackChangeType={(type) => this.setState({ paymentModal: type })}
            callbackDeleteSavedCard={() =>
              this.setCCSavedRemoveModalVisibility(true)
            }
            callbackApprovalSavedCard={(isBuyForHump, card) =>
              this.handleModalOfferApprovalSavedCard(isBuyForHump, card)
            }
            callbackApprovalAcceptance={(isBuyForHump, values) =>
              this.handleModalOfferApprovalAcceptance(isBuyForHump, values)
            }
            callbackApprovalMobile={(isBuyForHump) =>
              this.handleModalOfferApprovalMobile(isBuyForHump)
            }
            callbackCancel={() => this.handleModalOfferClose()}
          />
        );
      case PaymentModalType.ccSave:
        return (
          <CCSaveModal
            me={this.props.me}
            offer={this.offer}
            isLoading={
              this.props.answerState.loading ||
              this.state.answerResult?.state === AnswerStatus.PENDING
            }
            callback={(values) => this.handleModalCCSave(values)}
          />
        );
      default:
        return <React.Fragment />;
    }
  }

  private renderOption(id: number, index: number): ReactNode {
    return (
      <Option
        key={id}
        id={id}
        type={Helpers.getOptionTypeFromIndex(index)}
        isDisabled={this.isOptionDisabled(id)}
        callback={(id) => this.handleSelectOption(id)}
      />
    );
  }

  private renderQuestion(): ReactNode {
    if (this.props.getCurrentQuestionState.loading) {
      return <Loading />;
    } else if (this.props.getCurrentQuestionState.data) {
      const question = this.props.getCurrentQuestionState.data;
      const resultMedia = this.state.answerResult?.option?.mediaUrl;
      return (
        <React.Fragment>
          {this.state.isLottiePlayerLoading && (
            <Loading className="lottie-placeholder" fontSize={64} />
          )}
          {this.isAnswerResultStateSuccess() &&
          !this.state.instantRewardDescription &&
          resultMedia ? (
            <Player
              key={resultMedia}
              src={resultMedia}
              className="lottie-player"
              autoplay
              onEvent={(event) => {
                if (event === "complete") {
                  this.makeGameResultModalAvailableIfValid();
                }
              }}
            />
          ) : (
            <Player
              key={question.mediaUrl}
              src={question.mediaUrl}
              className="lottie-player"
              autoplay
              onEvent={(event) => {
                if (event === "play") {
                  this.setState({ isLottiePlayerLoading: false });
                }
              }}
            />
          )}
          <div className="options">
            {question.options
              .sort((a, b) => (a.orderIndex > b.orderIndex ? 1 : -1))
              .map((option, index) => this.renderOption(option.id, index))}
          </div>
        </React.Fragment>
      );
    }
    return <React.Fragment />;
  }

  render() {
    return (
      <div
        id="question-page"
        className="page"
        onClick={() => this.makeGameResultModalAvailableIfValid()}
      >
        <div className="page-content">{this.renderQuestion()}</div>
        {this.renderModalOffer()}
        {this.state.isCCSavedRemoveModalVisible && (
          <CCSavedRemoveModal
            callback={(isApproved) => this.handleModalCCSavedRemove(isApproved)}
          />
        )}
        {this.props.answerState.data?.redirectUrl && (
          <PayByMeModal url={this.props.answerState.data?.redirectUrl} />
        )}
        {this.state.answerResult?.state === AnswerStatus.PENDING_OTP && (
          <OtpModal
            isLoading={this.props.validateOtpState.loading}
            callbackSubmit={(values) => this.handleModalOtp(values)}
            callbackNewCode={() => this.handleModalOtpNewCode()}
          />
        )}
        {this.state.instantRewardDescription && (
          <InstantRewardModal
            rewardDescription={this.state.instantRewardDescription}
            callback={() => this.handleModalInstantReward()}
          />
        )}
        {this.state.isGameResultModalAvailable &&
          !this.state.instantRewardDescription &&
          this.isAnswerResultStateSuccess() && (
            <GameResultModal
              rewardDescription={Helpers.getRewardDescriptionFromRewards(
                this.state.answerResult?.rewards
              )}
              callback={() => this.handleModalGameResult()}
            />
          )}
        {this.state.isDailyLimitErrorVisible && (
          <DailyLimitErrorModal
            callback={() => this.handleModalDailyLimitError()}
          />
        )}
        {this.props.apiErrorState.error &&
          Errors.isHandledWithPaymentErrorModal(
            this.props.apiErrorState.error
          ) && (
            <PaymentErrorModal
              me={this.props.me}
              error={this.props.apiErrorState.error}
              callback={(type) => this.handleModalPaymentError(type)}
            />
          )}
      </div>
    );
  }

  componentWillUnmount() {
    if (this.state.optionsAvailabilityTimeout) {
      clearTimeout(this.state.optionsAvailabilityTimeout);
    }
    this.props.answerReset();
    this.props.getCurrentQuestionReset();
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getMe,
      getCurrentQuestion,
      getCurrentQuestionReset,
      pickedAnswer,
      answer,
      answerReset,
      deleteCard,
      validateOtp,
      setApiError,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    getCurrentQuestionState: store.getCurrentQuestion,
    answerState: store.answer,
    deleteCardState: store.deleteCard,
    validateOtpState: store.validateOtp,
    apiErrorState: store.setApiError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionPage);
